
export const EXAM_HOME = () => import('@/page/exam/examHome.vue')
export const DAY_PRACTICE = () => import('@/page/exam/dayPractice.vue')
// 真题
export const TRUE_TOPIC = () => import('@/page/exam/trueTopic.vue')
// 开始真题
export const START_TRUE_EXAM =()=>import('@/page/exam/startTrueExam.vue')
export const ASSESSMENT = () => import('@/page/exam/assessment.vue')
// 错题
export const WRONG = () => import('@/page/exam/wrongTopic.vue')
// 收藏
export const COLLECT = () => import('@/page/exam/collectTopic.vue')
// 错题集
export const QUESTION_RECORD = () => import('@/page/exam/questionRecord.vue')
// 答题卡
export const ANSWER_SHEET = () => import('@/page/exam/answerSheet.vue')
// 考试课程
export const EXAM_COURSE = () => import('@/page/exam/examCourse.vue')
// 章节练习
export const EXAM_CHAPTER = () => import('@/page/exam/examChapter.vue')
// 章节  开始做题
export const EXAM_CHANPTER_START = () =>import('@/page/exam/startExamChapter.vue')
// 模拟考试
export const MOCK_EXAM_LIST = () =>import('@/page/exam/mockExamList.vue')
// 开始模拟考试
export const MOCK_EXAM = () =>import('@/page/exam/startMockExam.vue')
// 错题解析
export const WRONG_ANALYSIS = () =>import('@/page/exam/wrongAnalysis.vue')




// WEBPACK FOOTER //
// ./src/router/exam.js